import React from 'react';
import { Card, Text } from 'library/ui';

export function PaymentStatus({ status }: { status: string }) {
    function getText() {
        if (status === 'BLOCKED') {
            return [
                'Due to repeated failed payments or a large unpaid balance, you are no longer able to post jobs.',
                'Your current jobs have either been canceled or are at risk of being canceled.',
                'Please update your payment method and retry payment on the Payments page as soon as possible.',
            ].join(' ');
        }

        return [
            'Your recent payments have failed.',
            'To avoid interruption of Tandem services, please update your payment method and retry payment on the Payments page as soon as possible.',
        ].join(' ');
    }

    return (
        <Card tone={status === 'BLOCKED' ? 'error' : 'warning'}>
            <Text tone={status === 'BLOCKED' ? 'error' : 'warning'}>{getText()}</Text>
        </Card>
    );
}
